import { useEffect, useState } from "react";
import "./style.css";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const marker = document.getElementById("scroll-top-marker");
    if (!marker) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // When marker goes out of view → user scrolled down
        setVisible(!entry.isIntersecting);
      },
      {
        root: null, // auto-detect actual scroll container
        threshold: 0,
      }
    );

    observer.observe(marker);

    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    const marker = document.getElementById("scroll-top-marker");
    if (marker) {
      marker.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={scrollToTop}
      className={`circle_scroll_button ${visible ? "show" : ""}`}
      aria-label="Scroll to top"
    >
      ↑
    </button>
  );
};

export default ScrollButton;
